export default __webpack_public_path__ + "static/media/electrical.663fb6bf.png";